import { Controller } from "@hotwired/stimulus";
import { Popover } from "bootstrap";

export default class extends Controller {
    connect() {
        this._popover = new Popover(this.element, {
            html: true,
            trigger: "manual",
            sanitize: true,
            allowList: {
                ...Popover.Default.allowList,
                a: ["href", "rel", "target"],
            },
            offset: [75, 8],
        });

        this._hideTimeout = null;

        // Desktop: hover
        this.element.addEventListener("mouseenter", this._show.bind(this));
        this.element.addEventListener("mouseleave", this._scheduleHide.bind(this));
        this.element.addEventListener("focus", this._show.bind(this));
        this.element.addEventListener("blur", this._scheduleHide.bind(this));

        // Mobile: tap to toggle
        this.element.addEventListener("touchend", this._onTouchEnd.bind(this));

        // Close when tapping outside on mobile
        this._onDocumentTouch = this._onDocumentTouch.bind(this);
        document.addEventListener("touchstart", this._onDocumentTouch);

        // Keep popover open when hovering over it so links can be clicked
        this.element.addEventListener("shown.bs.popover", () => {
            const tip = this._popover.getTipElement
                ? this._popover.getTipElement()
                : document.querySelector(".popover");
            if (tip) {
                tip.addEventListener("mouseenter", this._cancelHide.bind(this));
                tip.addEventListener("mouseleave", this._scheduleHide.bind(this));
            }
        });
    }

    _show() {
        this._cancelHide();
        this._popover.show();
    }

    _scheduleHide() {
        this._hideTimeout = setTimeout(() => this._popover.hide(), 150);
    }

    _cancelHide() {
        clearTimeout(this._hideTimeout);
    }

    _onTouchEnd(e) {
        e.preventDefault(); // prevent ghost mouse events
        e.stopPropagation();
        const tip = this._popover.getTipElement
            ? this._popover.getTipElement()
            : document.querySelector(".popover");
        const isVisible = tip && tip.classList.contains("show");
        isVisible ? this._popover.hide() : this._popover.show();
    }

    _onDocumentTouch(e) {
        const tip = this._popover.getTipElement
            ? this._popover.getTipElement()
            : document.querySelector(".popover");
        if (
            tip &&
            tip.classList.contains("show") &&
            !tip.contains(e.target) &&
            !this.element.contains(e.target)
        ) {
            this._popover.hide();
        }
    }

    disconnect() {
        document.removeEventListener("touchstart", this._onDocumentTouch);
        this._popover?.dispose();
    }
}